// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionMap, ITraduccionMapKeys, TraduccionMap} from "services-translation/modules/base/traduccion/map";

import idiomas from "./_idiomas";

export interface ITraduccionCmpInsistWindowPlatformActionMainKeys extends ITraduccionMapKeys {
    "app": string;
    "web": string;
}

export class TraduccionCmpInsistWindowPlatformActionMain extends TraduccionMap {
    /* STATIC */
    protected static override readonly ID: string = "cmp.insist_window.platform_action_main";
    private static VALUES?: ITraduccionMap;

    public static override build(lang: IIdioma): TraduccionCmpInsistWindowPlatformActionMain {
        this.VALUES ??= this.completar({
            "valor": {
                "ca": {
                    "valores": {
                        "app": "Subscriure'm",
                        "web": "Registrar-me"
                    }
                },
                "cs": {
                    "valores": {
                        "app": "Přihlášení k odběru",
                        "web": "Registrace"
                    }
                },
                "da": {
                    "valores": {
                        "app": "Abonner",
                        "web": "Registrer dig"
                    }
                },
                "de": {
                    "valores": {
                        "app": "Abonnieren",
                        "web": "Registrieren"
                    }
                },
                "en": {
                    "valores": {
                        "app": "Subscribe",
                        "web": "Register on our website"
                    }
                },
                "es": {
                    "valores": {
                        "app": "Suscribirme",
                        "web": "Registrarme"
                    }
                },
                "eu": {
                    "valores": {
                        "app": "Harpidetu",
                        "web": "Erregistratu"
                    }
                },
                "fi": {
                    "valores": {
                        "app": "Tilaa",
                        "web": "Rekisteröidy"
                    }
                },
                "fr": {
                    "valores": {
                        "app": "M'abonner",
                        "web": "M'enregistrer"
                    }
                },
                "gl": {
                    "valores": {
                        "app": "Subscribirse",
                        "web": "Rexistrarse"
                    }
                },
                "hi": {
                    "valores": {
                        "app": "सदस्यता लें",
                        "web": "रजिस्टर करें"
                    }
                },
                "hu": {
                    "valores": {
                        "app": "Feliratkozás",
                        "web": "Regisztráció"
                    }
                },
                "it": {
                    "valores": {
                        "app": "Iscriviti",
                        "web": "Registrati"
                    }
                },
                "nl": {
                    "valores": {
                        "app": "Inschrijven",
                        "web": "Registeren"
                    }
                },
                "no": {
                    "valores": {
                        "app": "Abonner",
                        "web": "Registrer deg"
                    }
                },
                "pl": {
                    "valores": {
                        "app": "Subskrybuj",
                        "web": "Zarejestruj się"
                    }
                },
                "pt": {
                    "valores": {
                        "app": "Subscrever",
                        "web": "Registar"
                    }
                },
                "pt-BR": {
                    "valores": {
                        "app": "Inscreva-se",
                        "web": "Cadastre-se"
                    }
                },
                "ro": {
                    "valores": {
                        "app": "Abonare",
                        "web": "Înregistrare"
                    }
                },
                "ru": {
                    "valores": {
                        "app": "Подписаться",
                        "web": "Зарегистрироваться"
                    }
                },
                "sk": {
                    "valores": {
                        "app": "Prihlásiť sa",
                        "web": "Zaregistrovať sa"
                    }
                },
                "sv": {
                    "valores": {
                        "app": "Prenumerera",
                        "web": "Registrera"
                    }
                },
                "tr": {
                    "valores": {
                        "app": "Abone ol",
                        "web": "Kayıt ol"
                    }
                }
            },
            "defecto": {
                "valores": {
                    "app": "Subscribe",
                    "web": "Sign up"
                }
            }
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
